<template>
  <!-- Score Entry Container -->
  <div class="score-entry-container">
    <div class="page-header">
      <div class="breadcrumb">ຄະແນນ / <span>ປ້ອນຄະແນນປະຈຳເດືອນ</span></div>
      <div class="header-content">
        <h1>ປ້ອນຄະແນນປະຈຳເດືອນ</h1>
        <p>ກະລຸນາເລືອກເງື່ອນໄຂ ແລະ ປ້ອນຄະແນນລາຍວິຊາຂອງນັກຮຽນໃຫ້ຄົບຖ້ວນ</p>
      </div>
    </div>
    <!-- Filter Section -->
    <div class="panel filter-panel">
      <div class="panel-head">
        <h3><i class="fas fa-filter"></i> ເງື່ອນໄຂການຄັດກອງ</h3>
      </div>
      <div class="panel-body">
        <div class="field-row">
          <div class="form-group">
            <label><i class="fas fa-graduation-cap"></i> ຊັ້ນຮຽນ</label>
            <select v-model="filters.Grade_Code" @change="fetchStudents">
              <option value="">-- ເລືອກຊັ້ນຮຽນ --</option>
              <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-calendar-alt"></i> ເດືອນ</label>
            <select v-model="filters.month" @change="fetchStudents">
              <option v-for="item in monthList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-history"></i> ສົກຮຽນ</label>
            <select v-model="filters.academicYear" @change="fetchStudents">
              <option value="">-- ເລືອກສົກຮຽນ --</option>
              <option v-for="item in accdList" :key="item.value" :value="item.text">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-door-open"></i> ຫ້ອງຮຽນ</label>
            <select v-model="filters.room_no" @change="fetchStudents">
              <option value="">-- ທັງໝົດ --</option>
              <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-book"></i> ວິຊາຮຽນ</label>
            <div class="input-with-action pointer" @click="openSubjectModal">
              <input type="text" :value="selectedSubjectLabel" readonly placeholder="ເລືອກວິຊາ">
              <button type="button" class="btn-icon">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <!-- Student List and Score Entry Table -->
    <div class="panel mt-4 table-panel" v-if="students.length > 0">
      <div class="panel-head">
        <h3><i class="fas fa-list-ol"></i> ລາຍຊື່ນັກຮຽນຊັ້ນ {{ selectedGradeName }}</h3>
        <span class="student-count">ທັງໝົດ: <strong>{{ students.length }}</strong> ຄົນ</span>
      </div>
      <div class="panel-body">
        <div v-if="loading" class="loading-state py-5 text-center">
          <i class="fas fa-spinner fa-spin fa-2x"></i>
          <p class="mt-2">ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
        </div>

        <div v-else class="table-wrap">
            
          <table class="score-table">
            <thead>
              <tr>
                <th>ລຳດັບ</th>
                <th>ລະຫັດ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <!-- <th v-for="sub in filteredSubjects" :key="sub.key" class="text-center">{{ sub.label }}</th> -->
                <th class="text-center">{{ selectedSubjectLabel }}</th> 
                 
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in students" :key="student._id">
                <td class="text-center">{{ index + 1 }}</td>
                <td><span class="asset-code">{{ student.student_id }}</span></td>
                <td class="student-name">{{ student.firstNameLao }} {{ student.familyNameLao }}</td>
                 <td   class="text-center">
                  <input 
                    type="number" 
                    v-model.number="student.scores" 
                    min="0" max="10" step="0.5"
                    class="score-input"
                    :class="{ 'low-score': student.scores !== '' && student.scores !== null && student.scores < 5 }"
                    @input="handleScoreInput(student)"
                  >
                </td> 
                
                
              
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions-footer mt-4">
          <button class="btn-save" @click="saveScores" :disabled="submitting">
            <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i> 
            {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຄະແນນທັງໝົດ' }}
          </button>
          <button class="btn-export" @click="exportToExcel" :disabled="students.length === 0">
            <i class="fas fa-file-excel"></i> ສົ່ງອອກ Excel
          </button>
        </div>
      </div>
    </div>
    
    <div v-else-if="filters.Grade_Code && !loading" class="empty-state mt-4 panel">
      <div class="panel-body text-center py-5">
        <i class="fas fa-users-slash fa-3x mb-3" style="opacity: 0.2"></i>
        <p>ບໍ່ພົບລາຍຊື່ນັກຮຽນໃນຊັ້ນຮຽນນີ້</p>
      </div>
    </div>

    <!-- Modal ເລືອກວິຊາຮຽນ -->
    <transition name="modal">
      <div v-if="showSubjectModal" class="modal-overlay" @mousedown.self="closeSubjectModal">
        <div class="custom-modal-card" role="dialog" aria-modal="true">
          <div class="custom-modal-header">
            <h3><i class="fas fa-book"></i> ເລືອກວິຊາຮຽນ</h3>
            <button @click="closeSubjectModal" class="close-btn">&times;</button>
          </div>
          <div class="custom-modal-search">
            <div class="input-container">
              <i class="fas fa-search search-icon"></i>
              <input 
                type="text" 
                v-model="subjectSearchQuery" 
                placeholder="ຄົ້ນຫາວິຊາ..."
                ref="subjectSearchInput"
              >
            </div>
          </div>
          <div class="custom-modal-body">
            <div class="list-item" @click="selectSubject({ key: '', label: 'ທຸກວິຊາ' })">
              <span class="item-name">-- ທຸກວິຊາ --</span>
              <i class="fas fa-check" v-if="filters.subject === ''"></i>
            </div>
            <div v-for="sub in filteredModalSubjects" :key="sub.key" class="list-item" @click="selectSubject(sub)">
              <span class="item-name">{{ sub.label }}</span>
              <i class="fas fa-check" v-if="filters.subject === sub.key"></i>
            </div>
          </div>
          <div class="custom-modal-footer">
            <button type="button" class="btn-modal-cancel" @click="closeSubjectModal">ປິດ</button>
          </div>
        </div>
      </div>
    </transition>
  </div> <!-- Corrected root container closing tag -->
</template>

<script>
import api from '@/utils/api';
import * as XLSX from 'xlsx'; // Import xlsx library

export default {
  name: 'ScoreEntryPage',
  data() {
    return {
      
      loading: false,
      submitting: false,
      filters: { Grade_Code: '', month: '9', academicYear: '2025-2026', subject: '' ,subjectLabel: '', room_no: ''},
      monthList: [
        { value: '1', text: 'ເດືອນ 1' },
        { value: '2', text: 'ເດືອນ 2' },
        { value: '3', text: 'ເດືອນ 3' },
        { value: '4', text: 'ເດືອນ 4' },
        { value: '5', text: 'ເດືອນ 5' },
        { value: '6', text: 'ເດືອນ 6' },
        { value: '7', text: 'ເດືອນ 7' },
        { value: '8', text: 'ເດືອນ 8' },
        { value: '9', text: 'ເດືອນ 9' },
        { value: '10', text: 'ເດືອນ 10' },
        { value: '11', text: 'ເດືອນ 11' },
        { value: '12', text: 'ເດືອນ 12' },
        { value: 'S1', text: 'ເສັງພາກຮຽນ 1' },
        { value: 'S2', text: 'ເສັງພາກຮຽນ 2' }
      ],
      showSubjectModal: false,
      subjectSearchQuery: '',
      classList: [],
      accdList: [],
      subjects: [],
      students: [],
      scoreData: {}, // Format: { studentId: { lao: 0, math: 0, ... } }
      user: JSON.parse(localStorage.getItem("user-info") || "{}")
    }
  },
  computed: {
    selectedGradeName() {
      const found = this.classList.find(c => c.value === this.filters.Grade_Code);
      return found ? found.text : this.filters.Grade_Code;
    },
    filteredSubjects() {
      if (!this.filters.subject) return this.subjects;
      return this.subjects.filter(s => s.key === this.filters.subject);
    },
    selectedSubjectLabel() {
      const sub = this.subjects.find(s => s.key === this.filters.subject);
      return sub ? sub.label : 'ເລືອກວິຊາ';
    },
    filteredModalSubjects() {
      if (!this.subjectSearchQuery) return this.subjects;
      const q = this.subjectSearchQuery.toLowerCase();
      return this.subjects.filter(s => s.label.toLowerCase().includes(q));
    }
  },
  mounted() {
    this.fetchClassList();
    this.fetchSubjects();
    this.fetchAccdList();
    // ເພີ່ມ event listener ສຳລັບປຸ່ມ Escape
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.enableScroll();
  },
  methods: {
    handleKeyDown(e) {
      if (e.key === 'Escape' && this.showSubjectModal) {
        this.closeSubjectModal();
      }
    },
    openSubjectModal() {
      this.disableScroll();
      this.showSubjectModal = true;
      this.subjectSearchQuery = '';
      this.$nextTick(() => {
        if (this.$refs.subjectSearchInput) this.$refs.subjectSearchInput.focus();
      });
    },
    closeSubjectModal() {
      this.showSubjectModal = false;
      this.enableScroll();
    },
    selectSubject(sub) {
      this.filters.subject = sub.key;
      this.filters.subjectLabel = sub.label;
      this.closeSubjectModal();
      this.fetchStudents(); // ເອີ້ນໃຊ້ fetchStudents ທັນທີຫຼັງຈາກເລືອກວິຊາ
    },
    disableScroll() { document.body.style.overflow = 'hidden'; },
    enableScroll() { document.body.style.overflow = ''; },
    async fetchClassList() {
      try {
        const response = await api.get('/getItems/class_list/class_desc_lao/id');
        this.classList = response.data;
      } catch (error) {
        console.error('Error fetching class list:', error);
      }
    },
    async fetchAccdList() {
      try {
        const response = await api.get('/getItems/accd/accd/id');
        // ຈັດລຽງຈາກໃຫຍ່ຫາໜ້ອຍ (Sort Descending)
        this.accdList = response.data.sort((a, b) => b.text.localeCompare(a.text));
      } catch (error) {
        console.error('Error fetching academic years:', error);
      }
    },
    async fetchSubjects() {
      try {
        const response = await api.get('/getItems/listsubjects/subject_name_lao/id');
        this.subjects = response.data.map(item => ({
          key: item.value,
          label: item.text
        }));
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    },
    async fetchStudents() {
      if (!this.filters.Grade_Code) return;
      this.loading = true;
      this.students = [];
      try {
        // ດຶງຂໍ້ມູນຜ່ານ report API ເພື່ອໃຫ້ໄດ້ທັງລາຍຊື່ນັກຮຽນ ແລະ ຄະແນນທີ່ເຄີຍບັນທຶກໄວ້ແລ້ວ
        const res = await api.get('/scores/report', {
          params: { 
            grade: this.filters.Grade_Code, 
            month: this.filters.month,
            academicYear: this.filters.academicYear,
            school_id: this.user.school_id ,
            subject: this.filters.subject,
            room_no: this.filters.room_no
          }
        });

        if (res.data.code === 1) {
          this.students = res.data.rows;
        //   const newData = {};
          
        //   this.students.forEach(student => {
        //     const initialScores = { rank: student.rank || null };
        //     this.subjects.forEach(sub => {
        //       // ຖ້າມີຄະແນນເກົ່າໃຫ້ເອົາມາສະແດງ, ຖ້າບໍ່ມີໃຫ້ເປັນ 0
        //       initialScores[sub.key] = (student.scores && student.scores[sub.key] !== undefined) 
        //         ? student.scores[sub.key] 
        //         : 0;
        //     });
        //     newData[student._id] = initialScores;
        //   });
          
        //   this.scoreData = newData;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    handleScoreInput(student) {
      if (student.scores > 10) {
        student.scores = 10;
      } else if (student.scores < 0) {
        student.scores = 0;
      }
    },
   
    async saveScores() {
      this.submitting = true;
      try {
        const payload = {
          month: this.filters.month,
          academicYear: this.filters.academicYear,
          grade: this.filters.Grade_Code,
          room_no: this.filters.room_no,
          roomLabel: this.filters.room_no ? `ຫ້ອງ ${this.filters.room_no}` : '',
          subject: this.filters.subject,
          subjectLabel: this.filters.subjectLabel,
          school_id: this.user.school_id,
          data: this.students.map(s => ({
            student_id: s._id,
            studentName: `${s.firstNameLao} ${s.familyNameLao}`,
            scores:  s.scores || 0, // ສະແດງຄະແນນທີ່ເກົ່າຂອງນັກຮຽນ, ຖ້າບໍ່ມີໃຫ້ເປັນ 0
            total: s.scores || 0 // ສະແດງຄະແນນທີ່ເກົ່າຂອງນັກຮຽນ, ຖ້າບໍ່ມີໃຫ້ເປັນ 0
          }))
        };
        const res = await api.post('/scores/bulk', payload);
        if (res.data.code === 1) {
          alert('ບັນທຶກຄະແນນ ແລະ ຈັດອັນດັບສຳເລັດແລ້ວ!');
          this.fetchStudents(); // ໂຫຼດຂໍ້ມູນຄືນໃໝ່ເພື່ອເບິ່ງອັນດັບ
        }
      } catch (e) {
        alert('ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກ');
      } finally {
        this.submitting = false;
      }
    },
    async exportToExcel() {
      if (this.students.length === 0) {
        alert('ບໍ່ມີຂໍ້ມູນນັກຮຽນທີ່ຈະສົ່ງອອກ.');
        return;
      }

      try {
        // ດຶງຂໍ້ມູນລາຍງານຄະແນນຈາກ Backend ເພື່ອໃຫ້ໄດ້ຂໍ້ມູນທີ່ຖືກຕ້ອງລວມທັງອັນດັບ
        const res = await api.get('/scores/report', {
          params: {
            month: this.filters.month,
            academicYear: this.filters.academicYear,
            grade: this.filters.Grade_Code,
            school_id: this.user.school_id
          }
        });

        if (res.data.code !== 1 || !res.data.rows) {
          alert('ບໍ່ສາມາດດຶງຂໍ້ມູນຄະແນນເພື່ອສົ່ງອອກໄດ້.');
          return;
        }

        const reportData = res.data.rows;

        // ສ້າງ Header ສໍາລັບ Excel
        const header = [
          'ລຳດັບ', 'ລະຫັດນັກຮຽນ', 'ຊື່', 'ນາມສະກຸນ', 'ເພດ',
          ...this.subjects.map(sub => sub.label), // ວິຊາຕ່າງໆ
          'ລວມ', 'ອັນດັບ'
        ];

        // ຈັດຮູບແບບຂໍ້ມູນ
        const data = reportData.map((student, index) => {
          const row = [index + 1, student.student_id, student.firstNameLao, student.familyNameLao, student.gender];
          this.subjects.forEach(sub => {
            row.push(student.scores[sub.key] !== undefined ? student.scores[sub.key] : 0);
          });
          row.push(student.total);
          row.push(student.rank || '-');
          return row;
        });

        const ws = XLSX.utils.aoa_to_sheet([header, ...data]); // ສ້າງ Worksheet
        const wb = XLSX.utils.book_new(); // ສ້າງ Workbook
        XLSX.utils.book_append_sheet(wb, ws, `ຄະແນນ_${this.filters.Grade_Code}_ເດືອນ${this.filters.month}`); // ເພີ່ມ Worksheet ເຂົ້າ Workbook
        XLSX.writeFile(wb, `ຄະແນນ_${this.filters.Grade_Code}_ເດືອນ${this.filters.month}_${this.filters.academicYear}.xlsx`); // ບັນທຶກໄຟລ໌
      } catch (error) {
        console.error('Error exporting to Excel:', error);
        alert('ເກີດຂໍ້ຜິດພາດໃນການສົ່ງອອກ Excel.');
      }
    }
  }
}
</script>

<style scoped>
.score-entry-container { animation: fadeIn 0.4s ease-out; max-width: 1200px; margin: 0 auto; }

.filter-panel { margin-bottom: 24px; }
.panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel-head h3 i { color: var(--lao); margin-right: 10px; }
.student-count {
  font-size: 14px;
  color: var(--text2);
}

.table-panel { border-radius: 12px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); }

.field-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; }
.form-group label { display: block; font-size: 13px; color: var(--text2); margin-bottom: 8px; font-weight: 600; }
.form-group input, .form-group select { width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }

/* Action Input Styles */
.input-with-action {
  position: relative;
  display: flex;
  align-items: center;
}
.input-with-action input {
  padding-right: 40px !important;
  cursor: pointer;
  background: white !important;
}
.btn-icon {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: var(--lao);
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.pointer { cursor: pointer; }

.table-wrap { max-height: 60vh; overflow-y: auto; border-radius: 8px; border: 1px solid var(--border); }
.score-table { width: 100%; border-collapse: separate; border-spacing: 0; }

.score-table th { 
  position: sticky; top: 0; background: #f8fafc; z-index: 10;
  padding: 15px 10px; border-bottom: 2px solid var(--border);
  font-weight: 700; color: var(--text1); text-transform: uppercase; font-size: 12px;
}

.score-table td { padding: 10px 8px; border-bottom: 1px solid #edf2f7; font-size: 14px; transition: background 0.2s; }
.score-table tr:hover td { background-color: #f8fafc; }
.score-table tr:nth-child(even) { background-color: #fafafa; }

.student-name { font-weight: 500; color: var(--text1); }
.asset-code { background: #e2e8f0; padding: 2px 8px; border-radius: 4px; font-family: monospace; font-size: 12px; color: #475569; }

.score-input { 
  width: 55px; padding: 8px 4px; border: 1.5px solid #e2e8f0; border-radius: 6px; 
  text-align: center; font-weight: 700; font-size: 15px; transition: all 0.2s;
  background: white;
}
.score-input:focus { outline: none; border-color: var(--lao); box-shadow: 0 0 0 3px rgba(0, 63, 138, 0.15); transform: scale(1.05); }

.score-input.low-score {
  color: #ef4444; border-color: #fecaca; background-color: #fef2f2;
}

.total-cell { font-weight: 800; color: var(--lao); background: #f0f9ff; text-align: center; font-size: 15px; border-left: 1px solid #e2e8f0; }
.total-cell.fail-total { color: #ef4444; background: #fff1f2; }

.rank-cell { 
  font-weight: 800; color: #b45309; text-align: center; background: #fffbeb; 
  font-size: 16px; border-left: 1px solid #fde68a;
}

.text-center { text-align: center; }

.form-actions-wrapper { 
  display: flex; 
  justify-content: space-between; 
  align-items: center;
  padding: 20px 0; 
  border-top: 1px solid var(--border);
}
.action-right { display: flex; gap: 12px; }

.btn-save {
  background: var(--lao); color: white; border: none; padding: 12px 25px;
  border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px;
  display: flex; align-items: center; gap: 8px; transition: 0.3s;
}
.btn-save:hover:not(:disabled) { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }

.btn-export {
  background: #10b981; color: white; border: none; padding: 12px 25px;
  border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px;
  display: flex; align-items: center; gap: 8px; transition: 0.3s;
}
.btn-export:hover:not(:disabled) { background: #059669; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }

.btn-export:disabled { opacity: 0.6; cursor: not-allowed; }

/* Empty State Styling */
.empty-state { border-radius: 12px; border: 2px dashed #e2e8f0; background: white; }
.empty-state i { color: #94a3b8; }
.empty-state p { color: #64748b; font-weight: 500; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Scrollbar Styling */
.table-wrap::-webkit-scrollbar { width: 8px; height: 8px; }
.table-wrap::-webkit-scrollbar-track { background: #f1f5f9; }
.table-wrap::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
.table-wrap::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

/* Modal Styles */
.modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(4px);
  display: flex; justify-content: center; align-items: center; z-index: 2000; padding: 20px;
}
.custom-modal-card {
  background: white; width: 100%; max-width: 480px; border-radius: 16px;
  display: flex; flex-direction: column; max-height: 80vh; overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1);
  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.custom-modal-header {
  padding: 20px 24px; border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.custom-modal-header h3 { margin: 0; font-size: 1.1rem; font-weight: 700; color: var(--lao); }
.close-btn {
  background: #f1f5f9; border: none; width: 32px; height: 32px; border-radius: 50%;
  cursor: pointer; color: #64748b; font-size: 20px;
}
.custom-modal-search { padding: 16px 24px; background: #f8fafc; border-bottom: 1px solid #f1f5f9; }
.custom-modal-search .input-container { position: relative; }
.custom-modal-search .search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; }
.custom-modal-search input {
  width: 100%; padding: 10px 10px 10px 40px; border: 1px solid #e2e8f0; border-radius: 10px; outline: none;
}
.custom-modal-body { flex: 1; overflow-y: auto; padding: 8px 0; }
.list-item {
  padding: 14px 24px; display: flex; justify-content: space-between; align-items: center;
  cursor: pointer; transition: 0.2s;
}
.list-item:hover { background: #f0f7ff; }
.list-item .item-name { font-size: 15px; color: #334155; font-weight: 500; }
.list-item i.fa-check { color: #10b981; }

.custom-modal-footer { padding: 16px 24px; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; }
.btn-modal-cancel {
  background: white; border: 1px solid #e2e8f0; padding: 8px 20px; border-radius: 8px;
  font-weight: 600; color: #64748b; cursor: pointer;
}

.modal-enter-active, .modal-leave-active { transition: opacity 0.25s ease; }
.modal-enter, .modal-leave-to { opacity: 0; }

@keyframes modalPop {
  from { opacity: 0; transform: scale(0.95) translateY(-10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
</style>